import controller from './controller';
import template from './template.html';

const controllerAs = 'userSearchCtrl';
const bindings = {
  certificationsArr: '<',
  compliance: '<',
  contentType: '<',
  departmentsArr: '<',
  departmentsDict: '<',
  dict: '=',
  edit: '<',
  filtered: '=',
  filters: '=',
  levelsArr: '<',
  levelsDict: '<',
  locationsArr: '<',
  locationsDict: '<',
  ngModel: '<',
  practicesArr: '<',
  practicesDict: '<',
  regulatorsArr: '<',
  regulatorsDict: '<',
  search: '<',
  searchReload: '<',
  setSearch: '&',
  style: '<',
  updateSearchParams: '<'
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/usersSearch/index.js